import { Injectable } from '@angular/core';
import { StampManagerType } from '@models/imported/SagaBase';
import { CStampCard } from '@models/imported/SagaSchema/CStampCard';
import { Task } from '@models/imported/SagaSchema/Task';
import { ListTaskStatus } from '@models/imported/SagaStateLib/ListTaskStatus';
import { FetchListService } from '@services/fetchlist/fetchlist.service';
import { IModelService, IObjectChange } from '@services/model-factory';

@Injectable({
  providedIn: 'root'
})
export class TaskModelService implements IModelService<Task> {
  constructor(private fetchListService: FetchListService) {}

  change(change: IObjectChange<Task>) {
    this.setTaskStatus(change.target);
  }

  private setTaskStatus(task: Task) {
    if (task.component(CStampCard).length > 0) {
      const taskStatusStamps = task.component<CStampCard>(CStampCard).filter(stamp => stamp.StampType === StampManagerType.TaskStatus);
      taskStatusStamps.sort((a, b) => b.CreatedUTC.getTime() - a.CreatedUTC.getTime());
      if (taskStatusStamps.length) {
        task.status = this.fetchListService.getRow(ListTaskStatus, taskStatusStamps[0].Status);
      }
    }

    if (!task.status) {
      task.status = this.fetchListService.getRow(ListTaskStatus, 1);
    }
  }
}
